<template>
  <div class="clearfix main_center" v-loading.fullscreen.lock="loading">
    <div class="top-content search-content busWinessLeft">
      <div class="left-navbar mainBtn">
        <el-button
          type="primary"
          v-preventReClick
          @click="submitData('save')"
          v-if="form.canEdit&&hasBtnPermission('supervise_double_extract_btn_save') "
        >保存</el-button>
        <el-button
          type="primary"
          v-preventReClick
          @click="back('resultNotice_detail',{id: form.id,flag: 2})"
          v-if="!form.canEdit&&hasBtnPermission('supervise_double_extract_btn_publish_result')"
        >发布检查结果公告</el-button>
        <el-button
          type="primary"
          v-preventReClick
          @click="changeStatus"
          v-if="form.historyid===0&& (form.enteredNum!=form.extractNum)&&hasBtnPermission('supervise_double_extract_btn_change')"
        >变更</el-button>
        <el-button v-preventReClick @click="submitData('beian')" v-if="form.historyid!=0&&hasBtnPermission('supervise_double_extract_btn_save')">备案</el-button>
      </div>
      <el-button  @click="back('project_extract_list')">返回</el-button>
    </div>
    <div class="right-content clearfix busWinessRight">
      <el-form label-width="180px" class="form" :model="form">
        <BaseInfo
          ref="baseInfo"
          :formData="form"
          @changebaseInfoFormMethods="changebaseInfoFormMethods"
        ></BaseInfo>
        <ProjectRule
          ref="projectRule"
          :formData="form"
          @changeProjectNumber="changeProjectNumber"
          @changeProjectFormMethods="changeProjectFormMethods"
          :filterDeptList.sync="form.filterDeptList"
        ></ProjectRule>
        <!--  :extractExectorsCopy.sync="form.extractExectors"
        :executorListCopy.sync="form.executorList"-->
        <PersonRule
          ref="personRule"
          :formData.sync="form"
          @setGroupData="setGroupData"
          @uploadParentForm="uploadParentForm"
          @saveAndRandom="saveAndRandom"
          @reloadPage="reloadPage"
        ></PersonRule>

        <!--  -->
        <ResuleCom
          ref="resuleCom"
          :formData="form"
          :resultTableData="resultTableData"
          :groupData="groupData"
          @changeExtractNum="changeExtractNum"
          :allForm_computed="allRuleForm"
        ></ResuleCom>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import BaseInfo from "./direct/direct_baseInfo";
import ProjectRule from "./direct/direct_projectRule";
import PersonRule from "./direct/direct_personRule";
import ResuleCom from "./direct/direct_result";
import { map } from "@antv/util";
export default {
  name: "extractResult",
  components: {
    BaseInfo,
    ProjectRule,
    PersonRule,
    ResuleCom
  },
  data() {
    return {
      count: 0,
      id: "",
      loading: false,
      extractNumberTypeList: [],
      groupData: [],
      form: {
        id: "",
        historyid: "-1",
        processinstanceid: "",
        processinstancecreatedate: "",
        businessType: "",
        entityId: "",
        flowId: "",
        extractType: "",
        inspectorsGroupType: "1",
        extractTypeName: "招投标项目", // 默认值
        tenderProjectCode: "",
        bidSectionCode: "",
        projectCode: "",
        superviseDeptCodeName: "",
        rejectCode: "",
        ruleType: 1, // 抽取规则类型  1,2,3
        extractRule: "", // 抽取规则
        mathRule: 1, // 小数位取整规则 1四舍五入 2向下取整 3向上取整
        workName: "",
        ruleCompMethod: "1",
        ruleCompMethodName: "",
        numOrPercentType: "1",
        taskId: "",
        extractCode: "",
        extractTime: "",
        extractNum: "",
        enteredNum: "",
        extractorName: "",
        supervisionIds: [],
        supervisionIdsName: "",
        superviseDeptCode: [],
        extractExectors: [],
        extractProjecttools: [], //结果表格
        matchingResultsType: "1",
        subjectLinkList: [],
        canEdit: true,
        groupAvg: 0,

        noticePubTimesNoEdit: "",
        contractSignTimesNoEdit: "",
        // 招标公告发布开始时间
        noticePubStartTime:'',
        //招标公告发布结束时间
        noticePubEndTime:'',
        //合同签署时间开始时间
        contractSignStartTime:'',
        //合同签署时间结束时间
        contractSignEndTime:'',

        filterDeptList:[]
      },
      taskId: "",
      ruleList: [],
      extractPondPersonList: [],
      resultTableData: [],
      groupTableData: [],
      extractTypeName: null,
      allRuleForm: {},
    };
  },
  filters: {},
  created() {
    this.getDic("extract_number_type");
  },
  computed: {
    ...mapState({
      stateData: state => state.user
    })
  },
  activated() {
    // $route.query.id为首页通过 url跳转 带过来的参数
    this.form.id = this.$route.query && this.$route.query.id;
    this.form.canEdit =
      this.$route.query.canEdit.toString() == "true" ? true : false;
    this.getDetailById();
  },
  watch: {
    allRuleForm:{
      deep: true,
      immediate: true,
      handler(newV, oldV) {
         this.allRuleForm=newV
      }
    }
  },
  methods: {
    uploadParentForm() {
      const {
        inspectorsGroupType,
        groupNum,
        extractExectors,
        groupAvg
      } = this.$refs.personRule.form;
      const {
        workName,
        extractCode,
        extractTime,
        extractorName,
        supervisionIds
      } = this.$refs.baseInfo.baseInfoForm;
      const {
        superviseDeptCode,
        projectName,
        tendererName,
        tenderAgencyName,
        noticePubTimes,
        contractSignTimes,
        extractNum
      } = this.$refs.projectRule.form;
      const { extractProjecttools,matchingResultsType } = this.$refs.resuleCom.form;
  
      this.form.inspectorsGroupType = inspectorsGroupType;
      this.form.groupNum = groupNum;
      this.form.extractExectors = extractExectors;
      this.form.groupAvg = groupAvg;
      this.form.executorList = extractExectors;

      this.form.workName = workName;
      this.form.extractCode = extractCode;
      this.form.extractTime = extractTime;
      this.form.extractorName = extractorName;
      this.form.supervisionIds = supervisionIds;

      this.form.superviseDeptCode = superviseDeptCode;
      this.form.projectName = projectName;
      this.form.tendererName = tendererName;
      this.form.tenderAgencyName = tenderAgencyName;
      this.form.noticePubTimes = noticePubTimes;
      this.form.contractSignTimes = contractSignTimes;


      this.form.extractNum = extractNum;
      this.form.extractProjecttools=extractProjecttools
      this.form.matchingResultsType=matchingResultsType

    },
    changebaseInfoFormMethods(val){
        // const {workName,extractCode,extractTypeName,supervisionIds,extractTime,extractorName}=val
        // Object.assign(this.allRuleForm,{workName,extractCode,extractTypeName,supervisionIds,extractTime,extractorName})
    },
    changePersionFormMethods(val){
      // const {inspectorsGroupType,groupNum}=val
      // Object.assign(this.allRuleForm,{inspectorsGroupType,groupNum})
    },
    changeProjectFormMethods(val){
      const {superviseDeptCode,projectName,tendererName,tenderAgencyName,noticePubTimes,contractSignTimes,ruleType,extractNum}=val
      
        // noticePubTimes:noticePubTimes?noticePubTimes.join(","):null,
        // contractSignTimes:contractSignTimes?contractSignTimes.join(","):null,
      Object.assign(this.allRuleForm,{
        superviseDeptCodeList:superviseDeptCode?superviseDeptCode:[],
        projectName:projectName||'',
        tendererName:tendererName||'',
        tenderAgencyName:tenderAgencyName||'',
        noticePubStartTime:noticePubTimes?noticePubTimes[0]:null,
        noticePubEndTime:noticePubTimes?noticePubTimes[1]:null,
        contractSignStartTime:contractSignTimes?contractSignTimes[0]:null,
        contractSignEndTime:contractSignTimes?contractSignTimes[1]:null,
        ruleType,extractNum})
    },
    changeExtractNum(extractProjecttools, extractNum) {
      this.form.extractProjecttools = extractProjecttools;
      this.form.extractNum = extractNum;
    },
    routerDetail(command, type) {
      if (type == "project") {
        let paramMap = {
          tenderProjectCode: command.tenderProjectCode || "",
          bidSectionCode: command.bidSectionCode || "",
          projectCode: command.projectCode || "",
          bidSectionName: command.projectName || "",
          applyCode: "",
          idcard: ""
        };
        window.sessionStorage.setItem(
          "witnessHisDetailParamMap",
          JSON.stringify(paramMap)
        );
        removeTabHandle("businessWitnessHis_detail");
        this.$router.push({
          name: "businessWitnessHis_detail",
          params: { paramMap: paramMap },
          query: {
            businessType: command.businessType,
            angleType: 0,
            purchaserMode: command.purchaserMode || ""
          }
        });
      }

      if (type == "result") {
        removeTabHandle("inspectionResult_detail");
        this.$router.push({
          name: "inspectionResult_detail",
          query: {
            id: command.checkResultBaseId || "",
            type: 1
          }
        });
      }
    },

    getDic(type) {
      // 获取字典
      this.$httpReq.get("/sys/dictData/getList?type=" + type).then(res => {
        if (res.data.code === "1") {
          switch (type) {
            case "extract_number_type":
              this.extractNumberTypeList = res.data.data;
              break;
            case "146":
              this.projectTypeList = res.data.data;
              break;
          }
        }
      });
    },
    reloadPage() {
      this.getDetailById();
    },
    //列表查看进来根据id查询详情
    getDetailById() {
      if (this.form.id) {
        // 查询任务基本信息
        this.$httpReq
          .get("/projectDoubleExtract/extracttask/get?id=" + this.form.id)
          .then(res => {
            if (res.data.code == "1") {
              let resData = res.data.data;
              this.form.historyid = resData.historyid;
              this.form.workName = resData.workName;
              this.form.extractCode = resData.extractCode;
              this.form.extractType = resData.extractType;

              this.form.extractTypeName = resData.extractTypeName;
              this.form.supervisionIds = resData.supervisionIds
                ? resData.supervisionIds.split(",")
                : [];
              this.form.supervisionIdsName = resData.supervisionIdsName;
              this.form.extractTime = resData.extractTime;
              this.form.extractorName = resData.extractorName;

              this.form.enteredNum = resData.enteredNum;
              this.form.extractNum = resData.extractNum;
              this.form.inspectorsGroupType = resData.inspectorsGroupType.toString();
              this.form.matchingResultsType = resData.matchingResultsType.toString();
              return;
            }
            this.$message.error(res.data.msg);
          });
        // 项目/交易主体抽取规则
        this.$httpReq
          .get(
            "/projectDoubleExtract/extractfilter/getExtractFilter?extractTaskId=" +
              this.form.id
          )
          .then(res => {
            if (res.data.code == "1" && res.data.data) {
              let resData = res.data.data;
              this.form.projectName = resData.projectName;
              this.form.superviseDeptCodeName = resData.superviseDeptCodeName;
              this.form.superviseDeptCode = resData.superviseDeptCodeList
              this.form.tendererName = resData.tendererName;
              this.form.tenderAgencyName = resData.tenderAgencyName;
              this.form.ruleType = resData.ruleType;
              this.form.extractRule = resData.extractRule;
              this.form.noticePubTimesNoEdit = resData.noticePubTimes
                ? resData.noticePubTimes.replace(",", " 至 ")
                : "";
              this.form.contractSignTimesNoEdit = resData.contractSignTimes
                ? resData.contractSignTimes.replace(",", " 至 ")
                : "";
              // noticePubEndTime
              // this.form.noticePubTimes =
              //   resData.noticePubTimes == ""
              //     ? resData.noticePubTimes
              //     : resData.noticePubTimes.split(",");
              // this.form.contractSignTimes =
              //   resData.contractSignTimes == ""
              //     ? resData.contractSignTimes
              //     : resData.contractSignTimes.split(",");

                  let PubStart=resData.noticePubStartTime?resData.noticePubStartTime:''
                  let PubEnd=resData.noticePubEndTime?resData.noticePubEndTime:''
                  let noticePubS=resData.contractSignStartTime?resData.contractSignStartTime:''
                  let noticePubE=resData.contractSignEndTime?resData.contractSignEndTime:''
                  this.form.noticePubTimes=[PubStart,PubEnd]
                  this.form.contractSignTimes =[noticePubS,noticePubE]
             
            }
          });
        // 执法人员抽取规则
        this.$httpReq
          .get(
            "/projectDoubleExtract/extractexectorfilter/getPersonAndRule?extractTaskId=" +
              this.form.id
          )
          .then(res => {
            if (res.data.code == "1" && res.data.data) {
              let dataInfo = res.data.data;
              // 执法检察人员列表
              this.extractPondPersonList = dataInfo.executorList || [];
              this.form.executorList = [...dataInfo.executorList] || [];
              this.form.extractPondPersonName = dataInfo.executorList
                .map(item => {
                  return (
                    item.personName +
                    (item.personDesc ? "(" + item.personDesc + ")" : "")
                  );
                })
                .join(",");
              this.$set(this.form, "extractExectors", dataInfo.executorList);
              // this.form.groupNum = dataInfo.executorFilter.groupNum || 0;
              this.$set(
                this.form,
                "groupNum",
                dataInfo.executorFilter.groupNum
              );
            } else {
              this.extractPondPersonList = [];
              this.form.groupNum = 0;
            }
          });

        // 获取选择执法人员和分组数
        this.$httpReq
          .get(
            "/projectDoubleExtract/extracttask/extractResultList?taskId=" +
              this.form.id
          )
          .then(res => {
            if (res.data.code == "1" && res.data.data) {
              let dataList = res.data.data;
              if (dataList.length == 0 && this.form.canEdit) {
                this.changeProjectNumber(this.form.extractNum);
              } else {
                dataList.forEach((element, index) => {
                  element.groupPerson = element.executorsIdsName;
                });
                this.resultTableData = dataList;
                this.form.extractProjecttools=[...dataList]
              }
            } else {
              this.resultTableData = [];
            }
          });
      }
    },

    // 返回
    back(routerName, paramskey) {
      tabsCloseCurrentHandle();
      this.$router.push({
        name: routerName,
        query: paramskey
      });
    },
    changeStatus(flag) {
      this.$set(this.form, "historyid", -1);
      this.$set(this.form, "canEdit", true);
    },
    saveAndRandom(callback) {
      this.submitData("save", callback);
    },

    submitData(flag, callback) {
      const baseform = new Promise((resolve, reject) => {
        this.$refs.baseInfo.validate(valid => {
          if (valid) {
            resolve();
          }
        });
      });
      const projectRule = new Promise((resolve, reject) => {
        this.$refs.projectRule.validate(valid => {
          if (valid) resolve();
        });
      });
      const personRule = new Promise((resolve, reject) => {
        this.$refs.personRule.validate(valid => {
          if (valid) resolve();
        });
      });
      const resuleCom = new Promise((resolve, reject) => {
        this.$refs.resuleCom.validate(valid => {
          if (valid) resolve();
        });
      });
      Promise.all([baseform, projectRule, personRule, resuleCom]).then(() => {
        //全部验证通过
        //写保存方法
        // console.log(this.$refs.baseInfo.baseInfoForm, 123);
        // console.log(this.$refs.projectRule.form, 123);
        // console.log(this.$refs.personRule.form, 123);
        // console.log(this.$refs.resuleCom.form, 123);
        const {
          workName,
          extractCode,
          extractTime,
          extractorName,
          supervisionIds
        } = this.$refs.baseInfo.baseInfoForm;
        const {
          superviseDeptCode,
          projectName,
          tendererName,
          tenderAgencyName,
          noticePubTimes,
          contractSignTimes,
          extractNum
        } = this.$refs.projectRule.form;
        const {
          inspectorsGroupType,
          groupNum,
          extractExectors,
          groupAvg
        } = this.$refs.personRule.form;
        const {extractProjecttools}=this.$refs.resuleCom.form
        // 循环项目 若是空数据 则去掉 保留非空数据
        let extractProjecttoolscopy=[]
        if(extractProjecttools.length>0){
         let filterProject= extractProjecttools.filter((element,inedx)=>{
             return element.projectName===''&&element.projectId===''
          })
          if(extractProjecttools.length===filterProject.length){
            extractProjecttoolscopy=[]
          }else if(filterProject.length>0&&extractProjecttools.length>filterProject.length){

            // extractProjecttoolscopy = extractProjecttools.filter(item => {
            //   return filterProject.find(element => {
            //     return item.projectId !== element.projectId;
            //   })
            // })
            extractProjecttoolscopy = extractProjecttools.filter(item => {
              return item.projectId !== '';
            })
          }else{
            extractProjecttoolscopy=[...extractProjecttools]
          }
        }
        let filterDeptitListcopy=[]
        if(superviseDeptCode&&superviseDeptCode.length>0){
            // 处理所属监管单位
            // console.log( this.form.filterDeptList,"处理所属监管单位");
            let filterDeptitem=[]
            superviseDeptCode.forEach((element)=>{
                filterDeptitem=this.form.filterDeptList.filter((item)=>{
                    return element==item.deptCode
                })
                filterDeptitListcopy.push(filterDeptitem[0]);
            })
        }
        let params = {
          id: this.form.id || "",
          type: 2,
          workName,
          extractCode,
          extractType: null,
          extractTime,
          extractorName,
          supervisionIds: supervisionIds.join(","),
          extractNum,
          extractFilter: {
            // superviseDeptCode: superviseDeptCode.join(","),
            //重构1
            filterDeptList:filterDeptitListcopy,
            projectName,
            tendererName,
            tenderAgencyName,
            // noticePubTimes: noticePubTimes ? noticePubTimes.join(",") : "",
            // contractSignTimes: contractSignTimes
            //   ? contractSignTimes.join(",")
            //   : "",

            //重构3
            // 招标公告发布开始时间
            noticePubStartTime:noticePubTimes?noticePubTimes[0]:null,
            //招标公告发布结束时间
            noticePubEndTime:noticePubTimes?noticePubTimes[1]:null,
            //合同签署时间开始时间
            contractSignStartTime:contractSignTimes?contractSignTimes[0]:null,
            //合同签署时间结束时间
            contractSignEndTime:contractSignTimes?contractSignTimes[1]:null,

            extractNum,
            ruleType: 1
          },
          extractExectors,
          extractExectorfilter: { groupNum, groupAvg },
          inspectorsGroupType,
          matchingResultsType: this.$refs.resuleCom.form.matchingResultsType,
          extractProjecttools: extractProjecttoolscopy
        };
        if (flag === "beian") {
          //-1未完成 0已完成
          params.historyid = 0;
          if(extractProjecttoolscopy.length!==extractNum){
                this.$message.error("请查看抽取项目是否有空行！")
                return
          }
          if(extractExectors.length==0){
            this.$message.error("请检查是否未选择执法人员！")
                return
          }
        
          let checkPersonisnullList=this.groupData.filter((element)=>{
                return element.name===''
          })
          if(checkPersonisnullList&&checkPersonisnullList.length>0){
            this.$message.error("请检查是否有执法检查人员分组为空！")
                return
          }
          let filtergroupNo= extractProjecttoolscopy.filter((item,index)=>{
            return item.groupNo==0
          })
          if(filtergroupNo&&filtergroupNo.length>0){
            this.$message.error("请检查是否有项目未选择执法人员！")
                return
          }

        }
        this.$httpReq({
          url: "/projectDoubleExtract/extracttask/directionalSave",
          method: "post",
          data: params
        }).then(res => {
          if (res.data.code == "1") {
            let dataInfo = res.data.data;
            this.form.id = dataInfo.id;
            // 调用保存后回显
            this.getDetailById();
            if (dataInfo.historyid == 0) {
              this.$message.success("备案成功");
              removeTabHandle('project_direct_extract')
              this.back("project_extract_list");
            } else {
                // 若是 点击开始随机分组 调用的保存 则有callback 不显示保存提示
                if(!callback){
                   this.$message.success("保存成功");
                }
            }
            if (callback) callback(dataInfo.id);
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });

    },
    changeProjectNumber(number) {
      let num = 0;
      if (this.count == 0) {
        num = number;
        this.count += 1;
      } else {
        num = number - this.resultTableData.length;
      }
      if (num > 0) {
        for (let j = 0; j < num; j++) {
          this.resultTableData.push({
            bidSectionName: "",
            bidSectionCode: "",
            projectTypeName: "",
            projectType: "",
            contractMoney: "",
            tenderBulletinDate: "",
            contractSignDate: "",
            groupNo: "", // 组号
            executorsIdsName: "", // 成员名
            indexNumber: j
          });
        }
      } else {
        this.resultTableData = this.resultTableData.slice(
          0,
          this.resultTableData.length + num
        );
      }
    },
    setGroupData(val) {
      this.groupData = val;
    }
  },
  deactivated() {}
};
</script>

<style lang="scss" scoped>
.role_table {
  width: 100%;
  padding: 0;
  margin: 0;
  border: 1px solid #ebeef5;
  border-spacing: 0;
  border-collapse: collapse;
  text-align: center;
  th {
    border: 1px solid #ebeef5;
    padding: 6px 10px;
    margin: 0;
    height: 44px;
    border-spacing: 0;
    border-collapse: collapse;
    color: #909399;
  }
  td {
    padding: 6px 10px;
    margin: 0;
    height: 44px;
    border-collapse: collapse;
    border-spacing: 0;
    border: 1px solid #ebeef5;
  }
}
</style>